import React from 'react';
import { IoArrowBackOutline } from "react-icons/io5";
import { t } from "i18next";
import styles from "./Pricing.module.css";

const PricingHeader = ({ onSeeAllPlans }) => {
    return (
        <div style={{ display: "flex", justifyItems: "center", alignItems: "center", width: "100%" }}>
            <IoArrowBackOutline 
                style={{ cursor: "pointer" }} 
                onClick={onSeeAllPlans} 
                size={40} 
            />
            <h1 className={styles.heading} style={{ marginLeft: "auto", marginRight: "auto" }}>
                {t('employer_plan.Our_Pricing_Plans')}
            </h1>
        </div>
    );
};

export default PricingHeader; 